import { SET_EXTERNAL_SOURCE_MODAL_FORM_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (value) =>
    actions[SET_EXTERNAL_SOURCE_MODAL_FORM_OPEN_STATUS](value);
